import React from "react";
import { useQuestionStateReducer } from "../AICoach/Tools";

export type QuestionStateContextType = ReturnType<typeof useQuestionStateReducer>;

export type QuestionStateProviderProps = {
  children: React.ReactNode,
  context: QuestionStateContextType
};

export const QuestionStateContext = React.createContext<QuestionStateContextType>({
  questionChanged: (event) => console.warn('no QuestionStateReducer in context, ignorning:', event)
});

export const QuestionStateProvider: React.FC<QuestionStateProviderProps> = ({ children, context }) => {
  return <QuestionStateContext.Provider value={context}>
    {children}
  </QuestionStateContext.Provider>
}
